import type { SVGProps } from 'react';

const SvgExposureNeg2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m15.05 16.29 2.86-3.07c.38-.39.72-.79 1.04-1.18s.59-.78.82-1.17.41-.78.54-1.17.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71A5.7 5.7 0 0 0 16.47 5c-.69 0-1.31.11-1.85.32s-1 .51-1.36.88c-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18q.465 0 .81.15c.345.15.43.25.59.43s.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7s-.32.53-.56.83c-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71zM2 11v2h8v-2z" />
  </svg>
);
export default SvgExposureNeg2;
